import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";

import { _addSmsLog } from "../Services/api-services";

import CustomizedSnackbars from "../Components/Snackbar";

import RandomDialog from "./randomDialog";
import { debounce } from "lodash";
import { get, patch, post } from "../Services/services";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";

function PaymentScheduleDialog(props) {
  const [formData, setFormData] = useState();
  const [totalSchedule, setTotalSchedule] = useState(0);
  const [paymentMethod, setPaymentMethod] = React.useState([]);
  const [disabled, setDisabled] = useState(false);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [history, setHistory] = useState([]);
  const [openChequeDialog, setOpenChequeDialog] = useState({
    open: false,
    index: null,
    isEdit: false,
  });
  const [chequeDetails, setChequeDetails] = useState({
    bankName: "",
    chequeNumber: "",
  });
  const [banks, setBanks] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const isSavingRef = useRef(false); 

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  const [chequeNumberError, setChequeNumberError] = useState("");

  const opens = Boolean(anchorEl);
  const menuOpen = Boolean(menuAnchorEl);

  const chequeNumberRegex = /^(?=.*\d)[A-Z0-9]{6,10}$/;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (event, index) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedRowIndex(index);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedRowIndex(null);
  };

  const handleHistoryClick = () => {
    const item = formData[selectedRowIndex];
    if (item?.dateArr?.length > 0) {
      setHistory(item.dateArr);
      setAnchorEl(menuAnchorEl);
      handleMenuClose();
    }
  };

  const handleEditClick = () => {
    handleEditBankDetails(selectedRowIndex);
    handleMenuClose();
  };

  let temp = "";

  const userName = props.userData?.name || "Unknown User";

  const tempdata = {
    date: "",
    paymentModeId: "",
    status: "",
    amount: "",
  };

  const validateChequeNumber = (value) => {
    if (!value.trim()) {
      return "Cheque number is required";
    }
    if (!chequeNumberRegex.test(value)) {
      return "Cheque number must be 6-10 alphanumeric characters";
    }
    return "";
  };

  const handleChequeNumberChange = (value) => {
    const cleanValue = value.replace(/\s/g, '').toUpperCase();

    setChequeDetails({ ...chequeDetails, chequeNumber: cleanValue });

    const error = validateChequeNumber(cleanValue);
    setChequeNumberError(error);
  };

  const handleEditBankDetails = (index) => {
    const item = formData[index];
    setChequeDetails({
      bankName: item.bankName || "",
      chequeNumber: item.chequeNumber || "",
    });
    setChequeNumberError("");
    setOpenChequeDialog({
      open: true,
      index: index,
      isEdit: true,
    });
  };

  const getPaymentStatus = async () => {
    const res = await get(
      'fields?filter={"where":{"status":true,"fieldType":"6549fec7d7788c592187b6c7"}}'
    );
    if (res.statusCode === 200) {
      setPaymentMethod(res?.data);
    }
  };

  const updateschedulespaymentStatus = async (status) => {
    const res = await patch(`subscribedCourses/${props?.courseData?._id}`, {
      paymentSchedule: status,
    });
    if (res.statusCode === 200) {
      // refreshCase();
    }
  };

  // const handleSave = async () => {
  //   if (props?.courseData?.totalFee - totalSchedule !== 0) {
  //     toast.error("Complete fee must be scheduled before saving.");
  //     return;
  //   }

  //   updateschedulespaymentStatus(true);

  //   const bulkData = [];
  //   const course = props?.courseData;

  //   for (let index = 0; index < formData.length; index++) {
  //     const schedule = formData[index];
  //     if (
  //       schedule.status !== "paid" ||
  //       schedule.tempstatus === "paid" ||
  //       schedule?.status === "bounce" ||
  //       schedule?.status === "pending"
  //     ) {
  //       const body = {
  //         amount: schedule.amount,
  //         date: schedule?.date,
  //         paymentModeId: schedule?.paymentModeId,
  //         status: schedule.status,
  //         chequeBounce: schedule?.chequeBounce,
  //         bankName: schedule?.bankName || "",
  //         chequeNumber: schedule?.chequeNumber || "",
  //       };

  //       if (schedule._id) {
  //         bulkData.push({ id: schedule._id, ...body });
  //       } else {
  //         bulkData.push({
  //           ...body,
  //           caseId: course?.caseId,
  //           currency: course?.currency?._id,
  //           conversionRate: course?.conversionRate,
  //           disabled: false,
  //           isRefund: false,
  //           subscribedCoursesId: course?._id,
  //           createdBy: userName,
  //         });
  //       }
  //     }
  //   }

  //   if (bulkData.length > 0) {
  //     await post("paymentSchedules/bulk-update", { data: bulkData });
  //   }

  //   props.refreshCase();
  //   setFormData();
  //   props.closePaymentDialog();
  // };
 
  const handleSave = async () => {
    if (isSavingRef.current) return;
    isSavingRef.current = true;
    setIsSaving(true);

    if (props?.courseData?.totalFee - totalSchedule !== 0) {
      toast.error("Complete fee must be scheduled before saving.");
      isSavingRef.current = false;
      setIsSaving(false);
      return;
    }

    updateschedulespaymentStatus(true);

    const bulkData = [];
    const course = props?.courseData;

    for (let index = 0; index < formData.length; index++) {
      const schedule = formData[index];
      if (
        schedule.status !== "paid" ||
        schedule.tempstatus === "paid" ||
        schedule?.status === "bounce" ||
        schedule?.status === "pending"
      ) {
        const body = {
          amount: schedule.amount,
          date: schedule?.date,
          paymentModeId: schedule?.paymentModeId,
          status: schedule.status,
          chequeBounce: schedule?.chequeBounce,
          bankName: schedule?.bankName || "",
          chequeNumber: schedule?.chequeNumber || "",
        };

        if (schedule._id) {
          bulkData.push({ id: schedule._id, ...body });
        } else {
          bulkData.push({
            ...body,
            caseId: course?.caseId,
            currency: course?.currency?._id,
            conversionRate: course?.conversionRate,
            disabled: false,
            isRefund: false,
            subscribedCoursesId: course?._id,
            createdBy: userName,
          });
        }
      }
    }

    if (bulkData.length > 0) {
      await post("paymentSchedules/bulk-update", { data: bulkData });
    }

    props.refreshCase();
    setFormData();
    props.closePaymentDialog();
    isSavingRef.current = false;
    setIsSaving(false);
  };



  const handleDateChange = (value, index) => {
    let temp = [...formData];

    if (temp[index].status === "paid") {
      const selectedDate = new Date(value);
      const today = new Date();

      const isFutureDate =
        selectedDate.getFullYear() > today.getFullYear() ||
        (selectedDate.getFullYear() === today.getFullYear() &&
          selectedDate.getMonth() > today.getMonth()) ||
        (selectedDate.getFullYear() === today.getFullYear() &&
          selectedDate.getMonth() === today.getMonth() &&
          selectedDate.getDate() > today.getDate());

      if (isFutureDate) {
        toast.error("Cannot set future date for payments marked as paid. Please select today's date or earlier.");
        return;
      }
    }

    temp[index].date = value;
    setFormData(temp);
  };

  const handleAmountChange = (value, index) => {
    let temp = [...formData];
    temp[index].amount = parseInt(value) ? parseInt(value) : 0;
    setFormData(temp);
  };

  const handleChangePaymentMode = (value, index) => {
    let temp = [...formData];
    const selectedMode = paymentMethod.find((mode) => mode.id === value);

    if (
      temp[index].paymentModeId === "66054b280ec67f1d01252713" &&
      selectedMode?.title !== "Cheque"
    ) {
      temp[index].bankName = "";
      temp[index].chequeNumber = "";
    }

    temp[index].paymentModeId = value;

    if (selectedMode?.title === "Cheque") {
      setChequeNumberError("");
      setOpenChequeDialog({ open: true, index: index, isEdit: false });
    } else {
      temp[index].bankName = "";
      temp[index].chequeNumber = "";
    }

    setFormData(temp);
  };

  const handleChangeStatus = (value, index) => {
    if (value === "bounce") {
      setOpen({ value: value, index: index });
    } else {
      let temp = [...formData];

      const paymentDate = new Date(temp[index].date);
      const today = new Date();

      const isFutureDate =
        paymentDate.getFullYear() > today.getFullYear() ||
        (paymentDate.getFullYear() === today.getFullYear() &&
          paymentDate.getMonth() > today.getMonth()) ||
        (paymentDate.getFullYear() === today.getFullYear() &&
          paymentDate.getMonth() === today.getMonth() &&
          paymentDate.getDate() > today.getDate());


      if (value === "paid" && isFutureDate) {
        toast.error("Future-dated payments cannot be marked as paid. Please update the payment date to today's date or earlier.");
        return;
      }

      temp[index].status = value;
      temp[index].tempstatus = "paid";
      setFormData(temp);
    }
  };

  const hanldeDelete = async (index) => {
    let temp = [...formData];
    temp.splice(index, 1);
    setFormData(temp);
  };

  const handleAddNew = async () => {
    let temp = [...formData];
    temp.push(tempdata);
    setFormData(temp);
  };

  const closeRandom = (d) => {
    if (d) {
      let temp = [...formData];
      temp[open.index].status = open?.value;
      temp[open.index].tempstatus = "paid";
      let data = { ...temp[open.index] };
      data.status = "";
      delete data._id;
      let charge = {
        date: "",
        paymentModeId: "",
        status: "",
        amount: props.courseData?.courses?.currencys?.chequeBounceCharge,
        chequeBounce: true,
      };
      temp = [...temp, charge, data];

      setFormData(temp);
    }
    setOpen(false);
  };

  const getBanks = async () => {
    const res = await post("fieldTypes/getAllFieldTypeWithField", { status: true });

    if (res.statusCode === 200) {
      res.data?.forEach((item) => {
        if (item.title === "banks") {
          setBanks(item?.field || []);
        }
      });
    }
  };

  const isChequePayment = (paymentModeId) => {
    const selectedMode = paymentMethod.find((mode) => mode.id === paymentModeId);
    return selectedMode?.title === "Cheque";
  };

  const hasHistory = (item) => {
    return item?.dateArr?.length > 0;
  };

  const hasBankDetails = (item) => {
    return item.bankName || item.chequeNumber;
  };

  useEffect(() => {
    if (props.PaymentDialog) {
      const schedules = props?.courseData?.paymentSchedules || props?.currentCourse?.paymentSchedules || [];
      let temp = schedules.map((item) => {
        return {
          ...item,
          date: moment(item.date).format("YYYY-MM-DD")
        };
      });
      setFormData(temp);
      getPaymentStatus();
    }
  }, [props.PaymentDialog, props.courseData, props.currentCourse]);

  useEffect(() => {
    getBanks();
  }, []);

  useEffect(() => {
    let i = 0;
    let disabled = false;
    for (let index = 0; index < formData?.length; index++) {
      if (
        !(
          formData[index].date?.length > 0 &&
          formData[index]?.status?.length > 0 &&
          formData[index]?.paymentModeId?.length > 0 &&
          formData[index]?.amount !== 0
        )
      ) {
        disabled = true;
      } else {
      }
      if (
        !formData[index].chequeBounce &&
        formData[index].status !== "bounce"
      ) {
        i = i + parseInt(formData[index].amount ? formData[index].amount : 0);
      }
    }
    setDisabled(disabled);
    setTotalSchedule(i);
  }, [formData]);

  return (
    <div className="">
      <Dialog fullWidth={true} maxWidth="md" open={props.PaymentDialog}>
        <DialogTitle sx={{ color: "gray" }}>PAYMENT SCHEDULE</DialogTitle>
        <Divider />
        <DialogContent>
          <Box>
            <Box className="flex gap-3 flex-wrap">
              <Box className="flex gap-1 items-center">
                <p className="text-[#707070] text-[12px]">course - </p>{" "}
                <p className="text-[#4CAF50] text-[15px]">
                  {" "}
                  {props?.courseData?.courseName}
                </p>
              </Box>
              <Box className="flex gap-1 items-center">
                <p className="text-[#707070] text-[12px]">Fee -</p>
                <p className="text-[#707070] text-[15px]">
                  {props?.courseData?.currency?.currencyName}
                </p>{" "}
                <p className="text-[#2B44FF] text-[15px]">
                  {props?.courseData?.totalFee}
                </p>
              </Box>
            </Box>

            <Box className="bg-[#F7F7F7] p-2 ">
              {formData?.map((item, index) => (
                <Box className="flex gap-5 items-center py-5" key={index}>
                  <TextField
                    type="date"
                    disabled={
                      (item.status === "paid" && item.tempstatus !== "paid") ||
                      item.status === "bounce"
                    }
                    fullWidth
                    required
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    label="DATE"
                    value={item?.date}
                    onChange={(e) => handleDateChange(e.target.value, index)}
                  />

                  <TextField
                    disabled={
                      (item.status === "paid" && item.tempstatus !== "paid") ||
                      item.status === "bounce"
                    }
                    size="small"
                    fullWidth
                    required
                    label={
                      item?.chequeBounce ? "cheque Bounce Charge" : "AMOUNT"
                    }
                    value={item.amount}
                    onChange={(e) => handleAmountChange(e.target.value, index)}
                  />
                  <FormControl
                    disabled={
                      (item.status === "paid" && item.tempstatus !== "paid") ||
                      item.status === "bounce"
                    }
                    required
                    fullWidth
                    size="small"
                  >
                    <InputLabel id="demo-select-small-label">
                      PAYMENT MODE
                    </InputLabel>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={item?.paymentModeId}
                      label="PAYMENT MODE"
                      onChange={(e) =>
                        handleChangePaymentMode(e.target.value, index)
                      }
                    >
                      {paymentMethod?.map((paymentItem) => (
                        <MenuItem key={paymentItem?.id} value={paymentItem?.id}>
                          {paymentItem?.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl
                    disabled={
                      (item.status === "paid" && item.tempstatus !== "paid") ||
                      item.status === "bounce"
                    }
                    required
                    fullWidth
                    size="small"
                  >
                    <InputLabel id="demo-select-small-label">STATUS</InputLabel>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={item?.status}
                      label="STATUS"
                      onChange={(e) =>
                        handleChangeStatus(e.target.value, index)
                      }
                    >
                      <MenuItem value="pending">Pending</MenuItem>
                      <MenuItem value="paid">Paid</MenuItem>
                      <MenuItem value="bounce">Bounce</MenuItem>
                    </Select>
                  </FormControl>

                  <Tooltip title="More options">
                    <IconButton
                      onClick={(e) => handleMenuClick(e, index)}
                      size="small"
                      sx={{ color: "#3366FF" }}
                    >
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Menu
                    anchorEl={menuAnchorEl}
                    open={menuOpen && selectedRowIndex === index}
                    onClose={handleMenuClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem
                      onClick={hasHistory(item) ? handleHistoryClick : undefined}
                      disabled={!hasHistory(item)}
                      sx={{
                        opacity: hasHistory(item) ? 1 : 0.5,
                        cursor: hasHistory(item) ? 'pointer' : 'not-allowed',
                      }}
                    >
                      <HistoryToggleOffIcon fontSize="small" sx={{ mr: 1 }} />
                      History {!hasHistory(item) && '(No history available)'}
                    </MenuItem>

                    {isChequePayment(item?.paymentModeId) && (
                      <MenuItem
                        onClick={hasBankDetails(item) ? handleEditClick : undefined}
                        disabled={!hasBankDetails(item)}
                        sx={{
                          opacity: hasBankDetails(item) ? 1 : 0.5,
                          cursor: hasBankDetails(item) ? 'pointer' : 'not-allowed',
                        }}
                      >
                        <EditIcon fontSize="small" sx={{ mr: 1 }} />
                        Edit Cheque Details {!hasBankDetails(item) && '(No details set)'}
                      </MenuItem>
                    )}
                  </Menu>

                  {/* History menu - separate from 3-dot menu */}
                  <Menu
                    id="history-menu"
                    anchorEl={anchorEl}
                    open={opens}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "history-button",
                    }}
                  >
                    {history?.map((items, historyIndex) => (
                      <MenuItem key={historyIndex} onClick={handleClose}>
                        {new Date(items)?.toUTCString()?.slice(0, -12)}
                      </MenuItem>
                    ))}
                  </Menu>

                  <RemoveCircleOutlineIcon
                    className={
                      item?._id || item?.chequeBounce
                        ? " "
                        : "text-[#3366FF] cursor-pointer"
                    }
                    onClick={() => {
                      if (!item._id && !item?.chequeBounce) {
                        hanldeDelete(index);
                      }
                    }}
                  />
                </Box>
              ))}

              <Box className="flex justify-between py-5">
                <Box>
                  <Box className="flex gap-1">
                    <p>
                      {totalSchedule}/{props?.courseData?.totalFee}
                    </p>
                    <p className="text-[#707070]">Created</p>{" "}
                  </Box>
                  <Box className="flex gap-1">
                    <p className="text-[#4CAF50]">
                      {props?.courseData?.totalFee - totalSchedule}{" "}
                    </p>
                    <p className="text-[#707070]">Remaining</p>
                  </Box>
                </Box>
                <Button onClick={handleAddNew}>
                  <AddIcon /> Add
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => {
              setFormData();
              props.closePaymentDialog();
              props.refreshCase();
            }}
            sx={{ marginY: "10px", minWidth: "0px" }}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            disabled={
              isSaving ||                            
              props?.courseData?.totalFee < totalSchedule ||
              !(formData?.length >= 0) ||
              disabled
            }
            onClick={handleSave}                    
            sx={{ marginY: "10px" }}
            variant="contained"
          >
            {isSaving ? <CircularProgress size={20} color="inherit" /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      <RandomDialog
        openRandomDialog={open}
        closeRandom={closeRandom}
        formData={formData}
      />

      {/* Cheque Details Dialog */}
      <Dialog
        open={openChequeDialog.open}
        onClose={() => {
          if (openChequeDialog.index !== null && !openChequeDialog.isEdit) {
            let temp = [...formData];
            temp[openChequeDialog.index].paymentModeId = "";
            setFormData(temp);
          }
          setOpenChequeDialog({ open: false, index: null, isEdit: false });
          setChequeDetails({ bankName: "", chequeNumber: "" });
          setChequeNumberError("");
        }}
      >
        <DialogTitle>
          {openChequeDialog.isEdit ? "Edit Cheque Details" : "Enter Cheque Details"}
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="dense">
            <InputLabel>Bank Name</InputLabel>
            <Select
              value={chequeDetails.bankName}
              label="Bank Name"
              onChange={(e) =>
                setChequeDetails({ ...chequeDetails, bankName: e.target.value })
              }
            >
              {banks.map((bank) => (
                <MenuItem key={bank._id || bank.title} value={bank.title}>
                  {bank.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            margin="dense"
            label="Cheque Number"
            value={chequeDetails.chequeNumber}
            onChange={(e) => handleChequeNumberChange(e.target.value)}
            onKeyDown={(e) => {
              if (!/[A-Za-z0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
                e.preventDefault();
              }
            }}
            error={!!chequeNumberError}
            helperText={chequeNumberError || "Enter 6-10 alphanumeric characters"}
            inputProps={{
              maxLength: 10,
              style: { textTransform: 'uppercase' }
            }}
            placeholder="e.g., CHQ123456"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (openChequeDialog.index !== null && !openChequeDialog.isEdit) {
                let temp = [...formData];
                temp[openChequeDialog.index].paymentModeId = "";
                setFormData(temp);
              }
              setOpenChequeDialog({ open: false, index: null, isEdit: false });
              setChequeDetails({ bankName: "", chequeNumber: "" });
              setChequeNumberError("");
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              const error = validateChequeNumber(chequeDetails.chequeNumber);
              if (error) {
                setChequeNumberError(error);
                return;
              }

              let temp = [...formData];
              const selectedMode = paymentMethod.find(
                (mode) => mode.id === temp[openChequeDialog.index].paymentModeId
              );

              if (selectedMode?.title === "Cheque") {
                temp[openChequeDialog.index] = {
                  ...temp[openChequeDialog.index],
                  bankName: chequeDetails.bankName,
                  chequeNumber: chequeDetails.chequeNumber,
                };
                setFormData(temp);
              }
              setOpenChequeDialog({ open: false, index: null, isEdit: false });
              setChequeDetails({ bankName: "", chequeNumber: "" });
              setChequeNumberError("");
            }}
            variant="contained"
            disabled={!!chequeNumberError || !chequeDetails.chequeNumber.trim()}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default PaymentScheduleDialog;